<template>
  <div class="w-full p-5">
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      @on-complete="confirmUpdate()"
    >
      <tab-content title="Isi Data" class="mb-5" icon="feather icon-edit">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Nomor Surat"
              v-model="input.nomor_surat"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Index / Judul Surat"
              v-model="input.surat.index"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Perihal"
              v-model="input.surat.perihal"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Lampiran"
              v-model="input.surat.lampiran"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <vs-input
              class="w-full"
              label-placeholder="Pengirim"
              v-model="input.pengirim"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <flat-pickr
              class="w-full"
              :config="configdateTimePicker"
              v-model="input.surat.tanggal"
              placeholder="Tanggal Surat"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="w-full">Catatan</label>
            <div class="w-full">
              <global-quill-editor
                v-model="input.surat.keterangan"
              ></global-quill-editor>
            </div>
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="" class="w-full">Isi Ringkas</label>
            <div class="w-full">
              <global-quill-editor
                v-model="input.surat.isi_ringkas"
              ></global-quill-editor>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content title="Pilih Kategori" class="mb-5" icon="feather icon-tag">
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="">Kode Surat</label>
            <vs-select
              :options="kodeSurat"
              class="w-full"
              label-placeholder="Catatan"
              v-model="input.surat.kode_surat_id"
              label="nama"
              :reduce="(kode) => kode.id"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="">Kategori Surat</label>
            <vs-select
              :options="selection.kategoriSurat.data"
              class="w-full"
              label-placeholder="Catatan"
              v-model="input.surat.kategori_surat_id"
              label="nama"
              :reduce="(kategori) => kategori.id"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="">Sifat Surat</label>
            <vs-select
              :options="selection.sifatSurat.data"
              class="w-full"
              label-placeholder="Catatan"
              v-model="input.surat.sifat_surat_id"
              label="nama"
              :reduce="(sifat) => sifat.id"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="">Kecepatan Surat</label>
            <vs-select
              :options="kecepatanSurat"
              class="w-full"
              label-placeholder="Kecepatan Surat"
              v-model="input.surat.kecepatan_surat_id"
              label="nama"
              :reduce="(kecepatan) => kecepatan.id"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label for="">Tipe Surat</label> 
            <br><br>
            <vs-radio
              name="tipe"
              v-model="input.tipe"
              vs-value="surat_masuk"
              class="mr-4"
              vs-name="layout-type-vertical"
            >
            Surat Masuk
            </vs-radio>
            <vs-radio
              name="tipe"
              v-model="input.tipe"
              vs-value="tembusan"
              class="mr-4"
              vs-name="layout-type-vertical"
            >
            Surat Tembusan
            </vs-radio>
          </div>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapActions } from "vuex";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { digofHttp } from "@/axios";

import { GET_FIELD_SELECTION } from "@/query/surat";
import { UPDATE, GET_ONE } from "@/query/surat-masuk";
import { CREATE as CREATE_DOKUMEN } from "@/query/dokumen";

export default {
  components: {
    "vs-select": vSelect,
    FormWizard,
    TabContent,
    flatPickr,
  },

  data() {
    return {
      input: {
        // Surat Masuk
        pengirim: null,
        nomor_surat: null,
        surat: {
          index: null,
          perihal: null,
          lampiran: null,
          isi_ringkas: null,
          keterangan: null,
          tanggal: null,
          kode_surat_id: null,
          kategori_surat_id: null,
          sifat_surat_id: null,
          kecepatan_surat_id: null,
        },
        tipe: null 
      },

      suratId: this.$route.params.uuid,

      configdateTimePicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
      },
      dokumen: [],

      // apollo data initiation
      // a.k.a default value
      selection: {
        kodeSurat: {
          data: [],
        },
        kategoriSurat: {
          data: [],
        },
        kecepatanSurat: {
          data: [],
        },
        sifatSurat: {
          data: [],
        },
        pengguna: {
          data: [],
        },
      },

      restKodeSurat: [],
    };
  },

  apollo: {
    suratMasuk: {
      query: GET_ONE,
      variables() {
        return {
          where: {
            column: "UUID",
            value: this.suratId,
          },
        };
      },
      update: (data) => {
        const suratMasuk = data.suratMasukGetOne;
        return suratMasuk;
      },
      fetchPolicy: "cache-and-network",
    },
    selection: {
      query: GET_FIELD_SELECTION,
      update: (data) => data,
      variables() {
        return {
          // assume show all data in pagination
          perPage: 1000000,
        };
      },
    },
  },

  computed: {
    user() {
      return this.$sanctum.getUser();
    },
    kodeSuratSelectionModified() {
      return this.selection.kodeSurat.data.map(({ id, kode_surat, nama }) => ({
        id,
        nama: `${kode_surat} - ${nama}`,
      }));
    },
    kecepatanSurat() {
      return this.selection.kecepatanSurat.data.map(
        ({ id, nama, keterangan }) => ({
          id,
          nama: `${nama} - ${keterangan}`,
        })
      );
    },
    kodeSurat() {
      return this.restKodeSurat.map(({ id, kode_surat, nama }) => ({
        id,
        nama: `${kode_surat} - ${nama}`,
      }));
    },
  },

  created() {
    this.$store.dispatch("globalApp/setEditTitle", "Edit Surat");
  },

  mounted() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Edit Surat Masuk");
    this.loadKodeSurat();
  },

  watch: {
    suratMasuk(value) {
      const suratMasuk = value;
      const surat = suratMasuk.surat;
      this.input = {
        pengirim: suratMasuk.pengirim,
        nomor_surat: suratMasuk.surat.nomor_surat.nomor,
        surat: {
          index: surat.index,
          perihal: surat.perihal,
          lampiran: surat.lampiran,
          isi_ringkas: surat.isi_ringkas,
          keterangan: surat.keterangan,
          tanggal: surat.tanggal,
          kode_surat_id: surat.kode_surat_id,
          kategori_surat_id: surat.kategori_surat_id,
          sifat_surat_id: surat.sifat_surat_id,
          kecepatan_surat_id: surat.kecepatan_surat_id,
        },
        tipe: suratMasuk.tipe
      };
    },
  },

  methods: {
    ...mapActions({
      toggleUploadSurat: "surat/toggleUploadSurat",
    }),

    confirmUpdate() {
      this.$root.confirmDialog({
        title: "Update Surat",
        message: "Yakin update surat?",
        acceptTitle: "Ya",
        cancelTitle: "Belum",
        onAccept: this.submit,
      });
    },
    async submit() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE,
          variables: {
            id: this.suratMasuk.id,
            input: {
              pengirim: this.input.pengirim,
              surat: {
                update: {
                  id: this.suratMasuk.surat.id,
                  ...this.input.surat,
                  nomor_surat: {
                    update: {
                      id: this.suratMasuk.surat.nomor_surat.id,
                      nomor: this.input.nomor_surat,
                      kode_surat: this.input.surat.kode_surat_id,
                    },
                  },
                },
              },
              tipe: this.input.tipe
            },
          },
        });
        this.$vs.notify({
          title: "Sukses",
          color: "success",
          text: "Berhasil simpan perubahan",
        });
        this.showDetail();
      } catch (error) {
        this.$vs.notify({
          title: "Gagal",
          color: "danger",
          text: "Gagal simpan perubahan",
        });
      }
    },

    showDetail() {
      const uuid = this.suratMasuk.surat.uuid;
      this.$router.push({
        name: "surat-lihat",
        params: { uuid },
      });
    },

    closeForm() {
      this.input = this.$objectReset(this.input);
      this.$store.dispatch("globalApp/toggleEdit", false);
    },

    fileChange() {
      const files = this.$refs.upload.filesx;
      if (!files.length) return;
      this.dokumen = Array.from(files).map((file) => this.makeDocument(file));
    },

    makeDocument(file) {
      return {
        dokumen_id: null, // need to update after create surat succeed
        dokumen_type: "App\\Models\\Surat",
        nama: file.name,
        jenis_dokumen: this.$getFileExtension(file),
        besar_dokumen: file.size,
        besar_dokumen_byte: file.size,
        tipe: "surat_keluar",
        lokasi: file,
      };
    },

    async createDokumen(input) {
      await this.$apollo.mutate({
        mutation: CREATE_DOKUMEN,
        variables: {
          input,
        },
      });
    },

    loadKodeSurat() {
      digofHttp
        .get(`/surat-keluar/kode-surat`)
        .then((r) => {
          this.restKodeSurat = r.data.data.kode_surat;
        })
        .then((e) => {
          console.log(e);
        });
    },
  },
};
</script>
